module.exports = __webpack_public_path__ + "media/Video 22.d6ef7197.mp4";